var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"banner",attrs:{"href":"https://websecuritymap.org","target":"_blank","rel":"nofollow"}},[_c('img',{attrs:{"src":"/static_frontend/web-security-map-logo-small.png","alt":"wsm logo","width":"20px"}}),_vm._v("️ "+_vm._s(_vm.$t("banner"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }